<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template #activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        <slot />
      </v-btn>
    </template>
    <form @submit.prevent="save">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>API Token Permissions</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <span>
            Permissions
          </span>
          <v-checkbox
            v-for="permission in availablePermissions"
            :key="permission"
            v-model="form.permissions"
            :label="permission"
            :value="permission"
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="cancel">
            Cancel
          </v-btn>
          <v-btn :loading="form.processing" color="primary" type="submit">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
export default {
   components: {
      //
   },

   props: {
      token: {
         type: Object,
         required: true
      },
      availablePermissions: {
         type: Array,
         required: true
      },
   },

   data () {
      return {
         dialog: false,

         form: this.$inertia.form({
            permissions: []
         })
      }
   },
   created () {
      this.form.permissions = this.token.abilities
   },
   methods: {
      cancel () {
         this.dialog = false
      },
      save () {
         this.form.put(this.route('api-tokens.update', this.token), {
            preserveScroll: true,
            preserveState: true,
         })
      },
   }
}
</script>
